import { useMutation, useQuery, useQueryClient } from "react-query";
import { getDeletedManufacturerList, hardDeleteManufacturer, restoreManufacturer } from "../../services/manufacturers";
import { useSnackbar } from "notistack";
import { convertDate } from "../../utils";

function DeletedManufacturer() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const deletedManufacturerListQuery = useQuery({
    queryKey: ["deletedManufacturerList"],
    queryFn: getDeletedManufacturerList,
  });

  const deletedManufacturerList = deletedManufacturerListQuery.data || [];

  const restoreManufacturerMutation = useMutation({
    mutationFn: restoreManufacturer,
    onSuccess: () => {
      enqueueSnackbar("Restore Manufacturer success!", { variant: "success" });
      queryClient.invalidateQueries("deletedManufacturerList");
      queryClient.invalidateQueries("manufacturerList");
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const hardDeleteManufacturerMutation = useMutation({
    mutationFn: hardDeleteManufacturer,
    onSuccess: () => {
      enqueueSnackbar("Hard Delete Manufacturer success!", { variant: "success" });
      queryClient.invalidateQueries("deletedManufacturerList");
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const handleRestore = (id) => {
    restoreManufacturerMutation.mutate(id);
  };

  const handleHardDelete = (id) => {
    if (window.confirm("Are you sure you want to permanently delete this manufacturer?")) {
      hardDeleteManufacturerMutation.mutate(id);
    }
  };

  return (
    <div>
      <h3 className="text-center">Deleted Manufacturer List</h3>
      <div>
        {deletedManufacturerListQuery.isLoading ? (
          "Loading"
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th scope="col">No</th>
                <th scope="col">Manufacturer Name</th>
                <th scope="col">Deleted at</th>
                <th scope="col">Restore</th>
                <th scope="col">Hard Delete</th>
              </tr>
            </thead>
            <tbody>
              {deletedManufacturerList.map((manufacturer, index) => (
                <tr key={manufacturer.manufacturer_id}>
                  <th scope="row">{index + 1}</th>
                  <td>{manufacturer.manufacturer_name}</td>
                  <td>{convertDate(manufacturer.updated_at)}</td>
                  <td>
                    <button
                      className="btn btn-success"
                      onClick={() => handleRestore(manufacturer.manufacturer_id)}
                    >
                      Restore
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleHardDelete(manufacturer.manufacturer_id)}
                    >
                      Delete Permanently
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default DeletedManufacturer;
